import { render, staticRenderFns } from "./surface_beethoven_preview.vue?vue&type=template&id=482c51ab&scoped=true&"
import script from "./surface_beethoven_preview.vue?vue&type=script&lang=js&"
export * from "./surface_beethoven_preview.vue?vue&type=script&lang=js&"
import style0 from "./surface_beethoven_preview.vue?vue&type=style&index=0&id=482c51ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c51ab",
  null
  
)

export default component.exports